/**
 * Reviews Slider Component
 * Initializes Swiper.js for reviews slider
 */

document.addEventListener('DOMContentLoaded', function () {
  const reviewsSections = document.querySelectorAll('[data-section-type="w-reviews-slider"]');

  reviewsSections.forEach((section) => {
    const swiperContainer = section.querySelector('.reviews-slider__swiper');
    const prevButton = section.querySelector('.reviews-slider__arrow--prev');
    const nextButton = section.querySelector('.reviews-slider__arrow--next');

    if (!swiperContainer) return;

    // Initialize Swiper
    const swiper = new Swiper(swiperContainer, {
      slidesPerView: 'auto',
      spaceBetween: 6,
      loop: false,
      speed: 400,
      breakpoints: {
        990: {
          slidesPerView: 3,
          spaceBetween: 8,
        },
      },
      on: {
        init: function () {
          updateNavigationButtons(this);
        },
        slideChange: function () {
          updateNavigationButtons(this);
        },
      },
    });

    // Navigation buttons
    if (prevButton) {
      prevButton.addEventListener('click', () => {
        swiper.slidePrev();
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', () => {
        swiper.slideNext();
      });
    }

    // Update navigation button states
    function updateNavigationButtons(swiperInstance) {
      if (prevButton) {
        if (swiperInstance.isBeginning) {
          prevButton.style.opacity = '0.3';
          prevButton.style.cursor = 'not-allowed';
        } else {
          prevButton.style.opacity = '1';
          prevButton.style.cursor = 'pointer';
        }
      }

      if (nextButton) {
        if (swiperInstance.isEnd) {
          nextButton.style.opacity = '0.3';
          nextButton.style.cursor = 'not-allowed';
        } else {
          nextButton.style.opacity = '1';
          nextButton.style.cursor = 'pointer';
        }
      }
    }
  });
});
